"use client";

import { ActiveFilters, FACET_KEYS, FacetKey } from "@/@types/filters";
import Tag from "@/components/Tag";
import styles from "./Filters.module.scss";
import { montserrat } from "./font";

interface Props {
  filters: ActiveFilters;
  onRemove: (key: FacetKey, value: string) => void;
  onClear: () => void;
}

/** Filtros ativos ao lado do botão, cada um removível. */
export default function ActiveFilterChips({ filters, onRemove, onClear }: Props) {
  const chips = FACET_KEYS.flatMap((key) =>
    filters[key].map((value) => ({ key, value }))
  );

  if (!chips.length) return null;

  return (
    <div className={`${styles.activeChips} ${montserrat.className}`}>
      {/* No mobile as pills saem de cena: o contador no botão já diz quantos
          filtros estão ativos, e a linha não comporta os dois. */}
      <div className={styles.chipsList}>
        {chips.map(({ key, value }) => (
          <Tag
            key={`${key}-${value}`}
            label={value}
            remove
            aria-label={`Remover filtro ${value}`}
            onClick={() => onRemove(key, value)}
          />
        ))}
      </div>

      <button type="button" className={styles.clearAll} onClick={onClear}>
        Limpar tudo
      </button>
    </div>
  );
}
